import { render } from "./AllxWhySmileMakeOver.vue?vue&type=template&id=c104f56c"
import script from "./AllxWhySmileMakeOver.vue?vue&type=script&lang=js"
export * from "./AllxWhySmileMakeOver.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__